// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Center the login card */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom right, #f3f4f6, #e5e7eb);
  font-family: "Poppins", sans-serif;
}

/* Card styling */
.login-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

/* Logo styling */
.login-logo {
  width: 90px;
  height: auto;
  margin-bottom: 1rem;
}

/* Title */
.login-title {
  margin-bottom: 1.5rem;
  color: #333;
  font-weight: 600;
}

/* Form styling */
.login-form input {
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.login-form input:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);
}

/* Button styling */
.login-form button {
  width: 100%;
  padding: 0.8rem;
  background-color: #4f46e5;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-form button:hover {
  background-color: #4338ca;
}

/* Footer link */
.login-footer {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #555;
}

.login-link {
  color: #4f46e5;
  font-weight: 500;
  text-decoration: none;
}

.login-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8DAA8D;EAC9D,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Center the login card */\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(to bottom right, #f3f4f6, #e5e7eb);\n  font-family: \"Poppins\", sans-serif;\n}\n\n/* Card styling */\n.login-card {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n}\n\n/* Logo styling */\n.login-logo {\n  width: 90px;\n  height: auto;\n  margin-bottom: 1rem;\n}\n\n/* Title */\n.login-title {\n  margin-bottom: 1.5rem;\n  color: #333;\n  font-weight: 600;\n}\n\n/* Form styling */\n.login-form input {\n  width: 100%;\n  padding: 0.8rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  outline: none;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.login-form input:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);\n}\n\n/* Button styling */\n.login-form button {\n  width: 100%;\n  padding: 0.8rem;\n  background-color: #4f46e5;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.login-form button:hover {\n  background-color: #4338ca;\n}\n\n/* Footer link */\n.login-footer {\n  margin-top: 1rem;\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.login-link {\n  color: #4f46e5;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.login-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
